import React from "react"


export default function CommandField({command}: { command: string }) {
    return <>
        <input
            className={"width-40 smaller solid"}
            type={"text"}
            value={command}
            disabled={false}
            readOnly={true}
            placeholder={""}
            onClick={(e) => {
                (e.target as HTMLInputElement).select()
            }
            }
            style={{backgroundColor: "#eeeeee"}}
        />
    </>
}